import { Pipe, PipeTransform } from '@angular/core';
import { floorToThreeDecimals } from '@app/helpers/number.helper';

@Pipe({
  name: 'threeDecimals',
  standalone: true,
})
export class ThreeDecimalsPipe implements PipeTransform {
  transform(value: number | null | undefined): number {
    if (value === null || value === undefined || value === Number.NaN) {
      return 0;
    }
    return floorToThreeDecimals(value);
  }
}
